import { Menu, MenuDivider, MenuItem, Position } from "@blueprintjs/core"
import CustomPopover, {
  CustomPopoverProps,
} from "components/Atoms/CustomPopover"
import React from "react"
import { capitalize } from "utils/stringFunctions"
import CustomButton from "../Atoms/CustomButton"
const ActionItems = ({ actions, item }) => {
  return (
    <Menu>
      {actions.map((action, index) => {
        const icon = action.icon
        const name = capitalize(action.name)
        const onClick = action.handler
        return (
          <div key={action.name}>
            <MenuItem
              icon={icon}
              text={name}
              onClick={() => onClick(item.id)}
            ></MenuItem>

            {actions.length === index + 1 ? null : <MenuDivider key={index} />}
          </div>
        )
      })}
    </Menu>
  )
}

type ActionsProps = {
  actions?: any[]
  item?: any
  children?: React.ReactNode
  popoverProps?: CustomPopoverProps
}
const Actions = ({
  actions,
  item,
  children = (
    <CustomButton
      style={{ transform: "rotate(90deg)" }}
      icon="more"
      minimal={true}
    />
  ),
  popoverProps,
}: ActionsProps) => {
  return (
    <CustomPopover
      position={Position.BOTTOM_LEFT}
      minimal={true}
      content={<ActionItems actions={actions} item={item}></ActionItems>}
      {...popoverProps}
    >
      {children}
    </CustomPopover>
  )
}

export default Actions
